import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { TrackPage } from './TrackPage';
import { ProfilePage } from './ProfilePage';
import { PlaylistPage } from './PlaylistPage';
import { MUSIC_TRACK_KIND, PLAYLIST_KIND } from '@/lib/musicTypes';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      return <ProfilePage pubkey={decoded.data} />;

    case 'nprofile':
      return <ProfilePage pubkey={decoded.data.pubkey} />;

    case 'note':
      // Note view not implemented
      return <NotFound />;

    case 'nevent':
      // Event view not implemented
      return <NotFound />;

    case 'naddr':
      // Check if it's a music track
      if (decoded.data.kind === MUSIC_TRACK_KIND) {
        return <TrackPage />;
      }
      // Check if it's a playlist
      if (decoded.data.kind === PLAYLIST_KIND) {
        return <PlaylistPage pubkey={decoded.data.pubkey} playlistId={decoded.data.identifier} />;
      }
      return <NotFound />;

    default:
      return <NotFound />;
  }
}